'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBoxField = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactIntl = require('react-intl');

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBoxField = exports.SearchBoxField = function (_Component) {
  (0, _inherits3.default)(SearchBoxField, _Component);

  function SearchBoxField() {
    var _ref;

    var _temp, _this, _this3, _ret;

    (0, _classCallCheck3.default)(this, SearchBoxField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchBoxField.__proto__ || (0, _getPrototypeOf2.default)(SearchBoxField)).call.apply(_ref, [this].concat(args))), _this3), _this3.inputRef = _react2.default.createRef(), _this3.blurInput = function () {
      var input = (0, _deep.deepExtract)('current', _this.inputRef);
      if (input) {
        input.blur();
      }
    }, _this3.handleSelect = function (item) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          onValueChange = _this$props.onValueChange,
          onClose = _this$props.onClose;


      _this.downshift.closeMenu();
      _this.blurInput();
      onValueChange('');
      onClose();
      onSelect(item);
    }, _this3.handleClear = function () {
      var onClear = _this.props.onClear;


      _this.downshift.clearSelection();

      onClear();
    }, _this3.handleChange = function (event) {
      var onValueChange = _this.props.onValueChange;


      onValueChange(event.target.value);
    }, _this3.handleFocus = function () {
      var _this$props2 = _this.props,
          onFieldFocus = _this$props2.onFieldFocus,
          onValueChange = _this$props2.onValueChange;


      onValueChange('');
      onFieldFocus();
    }, _this3.handleBlur = function () {
      var _this$props3 = _this.props,
          onValueChange = _this$props3.onValueChange,
          onClose = _this$props3.onClose,
          isOpenPanelOnMobile = _this$props3.isOpenPanelOnMobile;

      if (!isOpenPanelOnMobile) {
        onValueChange('');
        onClose();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(SearchBoxField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isOpen = _props.isOpen,
          inputValue = _props.inputValue,
          blurredValue = _props.blurredValue,
          isOpenPanelOnMobile = _props.isOpenPanelOnMobile,
          itemToString = _props.itemToString,
          placeholder = _props.placeholder,
          children = _props.children,
          icon = _props.icon,
          isClearable = _props.isClearable;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('searchbox__input', {
            'searchbox__input--selected': isOpen
          })
        },
        _react2.default.createElement(
          'div',
          { className: 'searchbox__input__icon' },
          icon
        ),
        _react2.default.createElement(
          _downshift2.default,
          {
            isOpen: isOpen,
            inputValue: isOpen ? inputValue : blurredValue,
            onSelect: this.handleSelect,
            itemToString: itemToString
          },
          function (downshift) {
            _this2.downshift = downshift;

            var getInputProps = downshift.getInputProps,
                isOpenLocal = downshift.isOpen;


            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', (0, _extends3.default)({}, getInputProps({
                autoComplete: 'off',
                onChange: _this2.handleChange,
                onFocus: _this2.handleFocus,
                onBlur: _this2.handleBlur,
                placeholder: placeholder
              }), {
                autoFocus: isOpen // eslint-disable-line jsx-a11y/no-autofocus
                , ref: _this2.inputRef
              })),
              isOpenLocal && children((0, _extends3.default)({
                onPanelScroll: isOpenPanelOnMobile ? _this2.blurInput : undefined
              }, downshift))
            );
          }
        ),
        isClearable && blurredValue && !isOpenPanelOnMobile && _react2.default.createElement(
          'div',
          { className: 'searchbox__input__icon searchbox__input__icon--light', onClick: this.handleClear },
          _react2.default.createElement(_reactInlinesvg2.default, { src: require('../../../../static/design-system/icons/cross-small-circle.svg') })
        )
      );
    }
  }]);
  return SearchBoxField;
}(_react.Component);

SearchBoxField.propTypes = {
  children: _propTypes2.default.func.isRequired,
  blurredValue: _propTypes2.default.string.isRequired,
  inputValue: _propTypes2.default.string.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  isOpen: _propTypes2.default.bool,
  isOpenPanelOnMobile: _propTypes2.default.bool,
  isClearable: _propTypes2.default.bool,
  itemToString: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.node,
  onClear: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onFieldFocus: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onValueChange: _propTypes2.default.func.isRequired
};